(function () {
  'use strict';

  angular
    .module('vctracker')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.tracker', {
        url: '/tracker',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;trackersearch tracker="" trackerref="" editinplace="true"&gt;</tt></h3><div ui-view="trackersearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;trackersearch tracker="" trackerref="" parentsave=""&gt;</tt></h3><div ui-view="trackersearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;trackereditor tracker="" mode="" onClose=""&gt;</tt></h3><div ui-view="trackereditview"></div>
              <h3 class="alert alert-info"><tt>&lt;trackernew&gt;</tt></h3><div ui-view="trackernewview"></div>
              <h3 class="alert alert-info"><tt>&lt;trackerlist trackers="?"&gt;</tt></h3><div ui-view="trackerlistview"></div>
              <h3 class="alert alert-info"><tt>&lt;trackervaluenew clientid="?"&gt;</tt></h3><div ui-view="trackervaluenewview"></div>
            `
          }
        },
        onEnter: function ($log) {
          $log.debug('debug/routes - playground.vctracker entered');
        }
      });
    
    
    $stateProvider
      .state('playground.tracker.allcomponents', {
        url: '/allcomponents',
        resolve: {
          tracker: function () {
            return '';
          },
          trackerref: function () {
            return '';
          },
          sometracker: function (Tracker) {
            return Tracker.$find('572b31b07c01597e3e150923');
          },
          alltrackers: function (Tracker) {
            return Tracker.$search({active: true});
          },
          parentsavesearch: function () {
            return function (tracker, trackerref) {
              console.log('debug: dummy parentsave called for trackersearch with: ', tracker, trackerref);
            };
          },
          eip: function () {
            return true;
          },
          clientid: function () {
            return '586fcf4fa60359ae2a632d64'; // Druide Miraculix
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'trackersearchview@playground.tracker': {
            component: 'trackersearch',
            bindings: {
              tracker: 'tracker',
              trackerref: 'trackerref',
              editinplace: 'eip'
            }
          },
          'trackersearchview2@playground.tracker': {
            component: 'trackersearch',
            bindings: {
              tracker: 'tracker',
              trackerref: 'trackerref',
              parentsave: 'parentsavesearch'
            }
          },
          'trackereditview@playground.tracker': {
            component: 'trackereditor',
            bindings: {
              tracker: 'sometracker'
            }
          },
          'trackernewview@playground.tracker': {
            component: 'trackernew',
            bindings: {
            }
          },
          'trackerlistview@playground.tracker': {
            component: 'trackerlist',
            bindings: {
              trackers: 'alltrackers'
            }
          },
          'trackervaluenewview@playground.tracker': {
            component: 'trackervaluenew',
            bindings: {
              cientid: 'clientid'
            }
          }
        },
        onEnter: function () {
          console.log('playground.tracker.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());






